import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'ep-text',
  template: `
   <div>EP-TEXT</div>
 `,
})
export class EPText extends FieldType {


}